import { of, pipe } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { ScriptDisplayResponse, ScriptErrorResponse } from '../code';
import { ScriptWorkerService } from '../services';
import { State } from '../services/work.state';

export const displayScript = (scriptWorker: ScriptWorkerService) =>
  pipe(
    switchMap(([state, currentState]: [Partial<State>, State]) => {
      if (state.system?.displayQ) {
        return scriptWorker
          .send$({
            type: 'display',
            question: state.system?.displayQ,
          })
          .pipe(
            map((res) => res as ScriptDisplayResponse | ScriptErrorResponse),
            map((dispResp) => {
              if (dispResp.type === 'error') {
                return {
                  ...state,
                  qNo: dispResp.question,
                  ...dispResp.data,
                  system: {
                    ...state.system,
                    error: dispResp.error.message,
                    navToQ: undefined,
                  },
                };
              }
              return {
                ...state,
                ...{
                  system: {
                    ...state.system,
                    displayQ: undefined,
                  },
                  blade: dispResp.blade || state.blade || currentState.blade,
                  qNo: dispResp.question,
                  qText: dispResp.text,
                  qInputs:
                    (state.inputs && state.inputs[state.system?.displayQ!]) ||
                    dispResp.inputs,
                },
              } as Partial<State>;
            }),
            map((state) => [state, currentState] as [Partial<State>, State])
          );
      } else {
        return of([state, currentState] as [Partial<State>, State]);
      }
    })
  );
